<form name="form" #f="ngForm">
  <div class="lv-fonds-modaldialog">
    <div class="lv-dialog-header">
      <div class="lv-dialog-header-title">
        Fondsauswahl
      </div>
      <div class="lv-dialog-header-close-icon">
        <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
      </div>
    </div>

    <div class="lv-scrollable">
      <table class="lv-fonds-table lv-fonds-table-hover-row" mat-table [dataSource]="dataSource" matSort matSortActive="name"
             matSortDirection="asc" matSortDisableClear>
        <ng-container matColumnDef="selected">
          <th class="lv-fonds-table-data-th-cell" mat-header-cell *matHeaderCellDef>&nbsp;</th>
          <td mat-cell class="lv-fonds-table-data-cell-first lv-fonds-table-data-cell-hover" *matCellDef="let element">
            <ng-container *ngIf="selectedFonds === element.fondsId">
              <mat-radio-button [checked]="true" (click)="selectFonds(element.fondsId)"></mat-radio-button>
            </ng-container>
            <ng-container *ngIf="selectedFonds !== element.fondsId">
              <mat-radio-button (click)="selectFonds(element.fondsId)"></mat-radio-button>
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell lv-fonds-table-cell-width-400">Fondsname / ISIN</th>
          <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-data-cell-hover">
            <ng-container>{{ element.name }} <br> {{ element.isin }}</ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="risikoklasse">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">SRI</th>
          <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell">{{element.risikoklasse}}</td>
        </ng-container>
        <ng-container matColumnDef="esgEinstufungTVO">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">ESG</th>
          <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell">Artikel {{element.esgEinstufungTVO}}</td>
        </ng-container>
        <ng-container matColumnDef="factsheet">
          <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">Factsheet</th>
          <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon"><a
              href="{{getLink('Factsheet', element.fondsId)}}" target="_blank">
            <mat-icon [svgIcon]="'DownloadToLine'"></mat-icon>
          </a></td>
        </ng-container>
        <ng-container matColumnDef="esgreport">
          <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">ESG-Report</th>
          <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon"><a
              href="{{getLink('ESG-Report', element.fondsId)}}" target="_blank">
            <mat-icon [svgIcon]="'DownloadToLine'"></mat-icon>
          </a></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectFonds(row?.fondsId)"></tr>
      </table>
    </div>

    <div mat-dialog-actions align="end">
      <div class="lv-fonds-modaldialog-footer-buttons">
        <button mat-raised-button class="lv-fonds-modaldialog-footer-button" color="accent" (click)="closeDialog()">
          Abbrechen
        </button>
        <button mat-raised-button class="lv-fonds-modaldialog-footer-button_accent" color="primary" [disabled]="!selectedFonds"
                (click)="fondsUebernehmen()">
          Fonds übernehmen
        </button>
      </div>
    </div>
  </div>
</form>
